import { useIsMobile } from '@core/hooks/useIsMobile';
import ExpandableSearch from './ExpandableSearch';
import SearchBar from './SearchBar';

export interface PageSearchConfig {
  placeholder: string;
  onSearch: (term: string) => void;
}

type PageSearchProps = PageSearchConfig & {
  size?: 'sm' | 'md';
};

const PageSearch: React.FC<PageSearchProps> = ({
  placeholder,
  onSearch,
  size = 'md',
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <SearchBar
        fullWidth
        placeholder={placeholder}
        onSearch={onSearch}
        onClear={() => onSearch('')}
        sx={{ mb: 0 }}
      />
    );
  }

  return (
    <ExpandableSearch
      placeholder={placeholder}
      onSearch={onSearch}
      size={size}
    />
  );
};

export default PageSearch;
